module.exports = __webpack_public_path__ + "static/media/articles.6ffb9f0d.png";